import React from "react";

export const CheckCircle: React.FC<any> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    {...props}
  >
    <g>
      <g>
        <path
          d="M2.5,10C2.5,5.8578600000000005,5.8578600000000005,2.5,10,2.5C14.1421,2.5,17.5,5.8578600000000005,17.5,10C17.5,14.1421,14.1421,17.5,10,17.5C5.8578600000000005,17.5,2.5,14.1421,2.5,10ZM13,7.375C12.8343,7.375,12.6753,7.44085,12.5581,7.55806L9,11.11613L7.44194,9.558060000000001C7.32473,9.44088,7.16576,9.375,7,9.375C6.65482,9.375,6.375,9.654810000000001,6.375,10C6.375,10.16575,6.44085,10.32475,6.55806,10.441939999999999L8.558060000000001,12.44194C8.80212,12.686,9.19788,12.686,9.441939999999999,12.44194L13.4419,8.441939999999999C13.5591,8.324729999999999,13.625,8.165759999999999,13.625,8C13.625,7.65482,13.3452,7.375,13,7.375Z"
          fill="#5BB98B"
          fillOpacity="1"
        />
      </g>
    </g>
  </svg>
);
